"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("../../../styles");
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var zIndex = _a.zIndex, palette = _a.palette;
    return ({
        root: {
            position: 'absolute',
            zIndex: zIndex.drawer + 1,
            color: palette.common.white
        }
    });
});
exports.default = useStyles;
